// import "./EmptyTodos.css"
function EmptyTodos() {
    return (
        <p>Crea tu primer TODO!</p>
    )
}
export { EmptyTodos }